"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateCalendar = exports.DateCalendarDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var fecha_1 = __importDefault(require("fecha"));
var time_display_1 = require("./time-display");
var cell_label_1 = require("./cell-label");
exports.DateCalendarDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 72px;\n  "], ["\n    min-width: 72px;\n  "])))
});
var DateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 0px;\n    border-radius: 2px;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: ", ";\n    border: 1px solid ", ";\n    padding: 0px;\n    border-radius: 2px;\n    font-size: ", ";\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('primary'), theme_1.theme.FONT_SIZE(20))
});
var MonthStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    align-items: baseline;\n    padding: ", " ", ";\n    justify-content: center;\n    align-self: stretch;\n    font-size: ", "em;\n    text-transform: uppercase;\n    background: ", ";\n    color: ", ";\n    font-weight: 600;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    align-items: baseline;\n    padding: ", " ", ";\n    justify-content: center;\n    align-self: stretch;\n    font-size: ", "em;\n    text-transform: uppercase;\n    background: ", ";\n    color: ", ";\n    font-weight: 600;\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2), 14 / 20, theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('light'))
});
var DayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 1em;\n    padding: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 1em;\n    padding: ", ";\n  "])), theme_1.theme.UNIT(0.5))
});
var YearStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: ", "em;\n    display: inline-block;\n    padding-left: ", ";\n  "], ["\n    font-weight: 400;\n    font-size: ", "em;\n    display: inline-block;\n    padding-left: ", ";\n  "])), 18 / 20, theme_1.theme.UNIT(1))
});
var TimeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    /* border-top: none; */\n    margin-top: ", ";\n  "], ["\n    /* border-top: none; */\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-left: 2px; \n    margin-bottom: ", ";\n  "], ["\n    padding-left: 2px; \n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1.5))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Date: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DateStyles),
  Month: styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), MonthStyles),
  Day: styled_components_1.default.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DayStyles),
  Year: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), YearStyles),
  Time: (0, styled_components_1.default)(time_display_1.TimeDisplay)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TimeStyles)
};
var DateCalendar = function (props) {
  var className = props.className,
    date = props.date,
    label = props.label;
  var parsed = fecha_1.default.parse(date, 'YYYY-MM-DDTHH:mm');
  var showTime = props.showTime;
  if (!parsed) {
    parsed = fecha_1.default.parse(date, 'YYYY-MM-DD');
    showTime = false;
  }
  if (!parsed) {
    return null;
  }
  var day = fecha_1.default.format(parsed, 'D');
  var month = fecha_1.default.format(parsed, 'MMM');
  var year = fecha_1.default.format(parsed, 'YYYY');
  return react_1.default.createElement(My.Container, {
    className: className
  }, label && react_1.default.createElement(My.Label, null, label), react_1.default.createElement(My.Date, null, react_1.default.createElement(My.Month, null, month, ' ', react_1.default.createElement(My.Year, null, year)), react_1.default.createElement(My.Day, null, day)), showTime && react_1.default.createElement(My.Time, {
    date: date
  }));
};
exports.DateCalendar = DateCalendar;
exports.DateCalendar.defaultProps = exports.DateCalendarDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;